import { NUM_CATEGORIES } from '@mc/constants'
import { useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import { TrackingContainer } from '@mc/visibility'
import CTA from 'components/CTA'
import { PricingText } from 'components/PricingText'
import { useLanguageCleanupExpAccessAllClasses } from 'experiments/pen-5840_v1_core_membership_language_cleanup'
import { trackCatalogPageRowViewed } from '../../events'
import { usePageData } from '../PageDataProvider'

export const AccessAllClasses = () => {
  const { t } = useTranslation('@mc/next')
  const languageCleanupExpAccessAllClasses =
    useLanguageCleanupExpAccessAllClasses()

  const { slug } = usePageData()

  return (
    <TrackingContainer
      onFirstVisible={() =>
        trackCatalogPageRowViewed({
          rowName: 'sign_up_bottom_section',
          categorySlug: slug,
        })
      }
    >
      <div className='container mc-text--center mc-py-10'>
        <div>
          <h2 className='mc-text-h2'>
            {languageCleanupExpAccessAllClasses ??
              t('categories.categoryPage.accessAllClasses.title', {
                instructors: getNumberOfInstructors(),
                categories: NUM_CATEGORIES,
              })}
          </h2>
          <div className='mc-pb-4' />
          <h3 className='mc-text-medium mc-text--light'>
            <PricingText />
          </h3>
        </div>
        <div className='mc-pb-6' />
        <CTA
          trackProps={{
            content_type: 'product',
            location: 'sign_up_bottom_section',
            category: slug,
          }}
        />
      </div>
    </TrackingContainer>
  )
}
